import { mutateConfig } from '../api/mutationConfig';
import { AccountStatus } from '../constants/account';

interface Props {
  url: string;
  cacheKey: string;
  status: string;
  name: string;
}

export const AccountStatusAction = ({ url, cacheKey, status, name }: Props) => {
  const { mutate: updateStatus, isPending, isError } = mutateConfig({ method: 'patch' })<void>({
    url,
    cacheKeys: [cacheKey],
  });

  const isBlocked = status?.toLowerCase() === AccountStatus.Blocked;

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();

    if (isBlocked) {
      if (window.confirm(`Unblock ${name}? They will be able to log in again.`)) {
        updateStatus({ status: AccountStatus.Allowed });
      }
      return;
    }

    const reason = window.prompt(`Reason for blocking ${name}?`);
    if (reason === null) return;
    if (reason.trim() === '') {
      window.alert('A reason is required to block an account.');
      return;
    }
    updateStatus({ status: AccountStatus.Blocked, remarks: reason.trim() });
  };

  return (
    <span className="inline-flex items-center gap-2">
      <button
        type="button"
        onClick={handleClick}
        disabled={isPending}
        aria-label={`${isBlocked ? 'Unblock' : 'Block'} ${name}`}
        className={`px-3 py-1.5 rounded-lg border border-gray-200 text-xs font-medium hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-colors ${
          isBlocked ? 'text-gray-700' : 'text-red-600'
        }`}
      >
        {isPending ? 'Saving...' : isBlocked ? 'Unblock' : 'Block'}
      </button>
      {isError && <span className="text-xs text-red-500">Failed</span>}
    </span>
  );
};
